/* tslint:disable */
/* eslint-disable */
/**
 * Trust Investigator APP
 * The Law Society Trust Investigation Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 2.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { AccountingAppIEnumerableResponse } from '../models';
import { Request } from '../models';
/**
 * AccountingAppApi - axios parameter creator
 * @export
 */
export const AccountingAppApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns AccountingApps
         * @param {Request} [body] 
         * @param {boolean} [showActiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccountingAppGetAccountingAppsPost: async (body?: Request, showActiveOnly?: boolean, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/AccountingApp/GetAccountingApps`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (showActiveOnly !== undefined) {
                localVarQueryParameter['showActiveOnly'] = showActiveOnly;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountingAppApi - functional programming interface
 * @export
 */
export const AccountingAppApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns AccountingApps
         * @param {Request} [body] 
         * @param {boolean} [showActiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AccountingAppGetAccountingAppsPost(body?: Request, showActiveOnly?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountingAppIEnumerableResponse>> {
            const localVarAxiosArgs = await AccountingAppApiAxiosParamCreator(configuration).apiV2AccountingAppGetAccountingAppsPost(body, showActiveOnly, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AccountingAppApi - factory interface
 * @export
 */
export const AccountingAppApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Returns AccountingApps
         * @param {Request} [body] 
         * @param {boolean} [showActiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccountingAppGetAccountingAppsPost(body?: Request, showActiveOnly?: boolean, options?: any): AxiosPromise<AccountingAppIEnumerableResponse> {
            return AccountingAppApiFp(configuration).apiV2AccountingAppGetAccountingAppsPost(body, showActiveOnly, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccountingAppApi - object-oriented interface
 * @export
 * @class AccountingAppApi
 * @extends {BaseAPI}
 */
export class AccountingAppApi extends BaseAPI {
    /**
     * 
     * @summary Returns AccountingApps
     * @param {Request} [body] 
     * @param {boolean} [showActiveOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingAppApi
     */
    public apiV2AccountingAppGetAccountingAppsPost(body?: Request, showActiveOnly?: boolean, options?: any) {
        return AccountingAppApiFp(this.configuration).apiV2AccountingAppGetAccountingAppsPost(body, showActiveOnly, options).then((request) => request(this.axios, this.basePath));
    }
}
